import { Box, Typography } from "@mui/material";
import Sinabank from "../../../../../../media/images/Sina-bank-logo-Vector 1.svg";
import { addCommas } from "@persian-tools/persian-tools";

export default function ActiveRequestCard() {
  return (
    <Box
      sx={{
        mt: 1,
        borderRadius: "10px",
        border: "solid",
        borderColor: "info.main",
        borderWidth: "1px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <img src={Sinabank} alt="" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "3px",
          }}
        >
          <Typography
            color={"primary.main"}
            sx={{
              fontSize: "14px",
            }}
          >
            {addCommas(2000000)} ریال
          </Typography>
          <Box>
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              ۱۴۰۲/۱۲/۰۴ - ۱۰:۳۵
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "700",
          }}
        >
          10234567890123456
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            color: "textColor.light",
          }}
        >
          بانک ایران زمین{" "}
        </Typography>
      </Box>
    </Box>
  );
}
